/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField, NumberField } from '@molecules';
import { Form } from '@organisms';
import { Block, ErrorMessage } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';

import { FORM_FIELD } from './constants';

const LocationForm = ({ initialValues = {}, error, form }) => {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <TextField {...FORM_FIELD.LOCATION_NAME} />
        <Form.Item label="Location coordinates:" style={NO_MARGIN_BOTTOM}>
          <NumberField
            {...FORM_FIELD.LATITUDE}
            label={<div style={{ fontFamily: 'World Athletics' }}>{FORM_FIELD.LATITUDE.label}</div>}
            style={{
              ...NO_MARGIN_BOTTOM,
              display: 'inline-block',
              width: 'calc(50% - 10px)',
            }}
          />
          <NumberField
            {...FORM_FIELD.LONGITUDE}
            label={<div style={{ fontFamily: 'World Athletics' }}>{FORM_FIELD.LATITUDE.label}</div>}
            style={{
              ...NO_MARGIN_BOTTOM,
              display: 'inline-block',
              width: 'calc(50% - 10px)',
              marginLeft: '20px',
            }}
          />
        </Form.Item>
      </Block>
    </Form>
  );
};

LocationForm.useForm = () => Form.useForm(FORM_FIELD);

export default LocationForm;
